import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { DEPRECATED_Typography } from "../../../../components/DEPRECATED_Typography";
import { getActiveItemIndex } from "../../../../components/PrizeLocator/utils/getActiveItemIndex";
import { useHorizontalSwipe } from "../../../../hooks/useHorizontalSwipe/useHorizontalSwipe";
import { usePrizeLocatorContext } from "../../hooks";
import { CategoryFilterItem } from "./CategoryFilterItem";
import styles from "./CategoryFilter.module.scss";
const getFiltersWithStatus = (filters, activeFilters) => filters.map((filter) => {
    const isActive = getActiveItemIndex(filter.categoryKey, activeFilters) !== -1;
    if (isActive) {
        return { ...filter, isActiveFilter: true };
    }
    return filter;
});
export const CategoryFilter = ({ onFilterClick, activeFilters, filters }) => {
    const ulRef = useRef(null);
    const { onTouchEnd, onTouchMove, onTouchStart, elementPositionX } = useHorizontalSwipe(ulRef);
    const { labels: { categoryFilterTitle }, } = usePrizeLocatorContext();
    const filtersWithStatus = getFiltersWithStatus(filters, activeFilters);
    if (filtersWithStatus?.length < 1)
        return null;
    return (_jsxs("div", { className: styles.categoryFilter, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, onTouchCancel: onTouchEnd, children: [_jsx(DEPRECATED_Typography, { type: "p1", color: "black", className: styles.categoryFilterTitle, children: categoryFilterTitle }), _jsx("ul", { style: { transform: `translateX(${elementPositionX}px)` }, className: styles.list, ref: ulRef, children: filtersWithStatus.map(({ categoryKey, iconUrl, label, isActiveFilter }) => (_jsx(CategoryFilterItem, { categoryKey: categoryKey, iconUrl: iconUrl, label: label, onFilterClick: onFilterClick, isActiveFilter: isActiveFilter }, categoryKey))) })] }));
};
//# sourceMappingURL=CategoryFilter.js.map